<template>
	<div>
		<el-form :inline="true" style="border-bottom: 1px #eee solid;">
			<el-form-item label="搜索">
				<el-input v-model="nameSearch" placeholder="按名称搜索" size="medium">
					<i slot="prefix" class="el-input__icon el-icon-search"></i>
				</el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="query" size="medium">搜索</el-button>
			</el-form-item>
		</el-form>

		<el-table v-loading="tableLoading" :data="tableData" height="450">
			<el-table-column type="index" label="序号" width="50"> </el-table-column>
			<el-table-column prop="name" label="工序组"> </el-table-column>
			<el-table-column label="操作" width="150">
				<template slot-scope="scope">
					<el-popover placement="right" width="350" trigger="click">
						<ProcessDetails :groupId="currentGroupId" v-if="scope.row._id.$oid == currentGroupId" />
						<el-button type="text" slot="reference" size="mini" @click="handleView(scope.row)">查看</el-button>
					</el-popover>

					<el-button style="margin-left:20px;" size="mini" @click="handleSelect(scope.row)">设置</el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	import { processGroupRequest } from '@/network/requests/processGroup'
	import ProcessDetails from './ProcessDetails'
	export default {
		components: {
			ProcessDetails,
		},
		data() {
			return {
				tableData: [],
				tableLoading: false,
				currentRow: null,
				nameSearch: '',
				currentGroupId: '',
			}
		},
		methods: {
			/**
			 * 查询工序组。
			 */
			query() {
				this.tableLoading = true
				processGroupRequest
					.queryAll({ name: { $regex: this.nameSearch } })
					.then(res => {
						var array = []
						res.forEach((v, i) => {
							array.push({ ...v })
						})

						this.tableData = array
					})
					.finally(() => {
						this.tableLoading = false
					})
			},
			/**
			 * 查看工序。
			 */
			handleView(row) {
				this.currentGroupId = row._id.$oid
			},
			/**
			 * 选择工序组。
			 */
			handleSelect(row) {
				this.$emit('select', row)
			},
		},
		created() {
			this.query()
		},
	}
</script>

<style></style>
